import React from 'react'

export const TradeSvg = () => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23.2983 11.6667H4.63166V21C4.63166 24.5 5.79833 25.6667 9.29833 25.6667H18.6317C22.1317 25.6667 23.2983 24.5 23.2983 21V11.6667Z'
        stroke='#343434'
        stroke-width='2'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M25.0833 8.16667V9.33333C25.0833 10.6167 24.465 11.6667 22.75 11.6667H5.25C3.465 11.6667 2.91666 10.6167 2.91666 9.33333V8.16667C2.91666 6.88333 3.465 5.83333 5.25 5.83333H22.75C24.465 5.83333 25.0833 6.88333 25.0833 8.16667Z'
        stroke='#343434'
        stroke-width='2'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M13.58 5.83333H7.14C6.74333 5.40167 6.755 4.73667 7.175 4.31667L8.83166 2.66C9.26333 2.22833 9.975 2.22833 10.4067 2.66L13.58 5.83333Z'
        stroke='#343434'
        stroke-width='2'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M20.8483 5.83333H14.4083L17.5817 2.66C18.0133 2.22833 18.725 2.22833 19.1567 2.66L20.8133 4.31667C21.2333 4.73667 21.245 5.40167 20.8483 5.83333Z'
        stroke='#343434'
        stroke-width='2'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M10.43 11.6667V17.6633C10.43 18.5967 11.4567 19.145 12.2383 18.6433L13.335 17.92C13.7317 17.6633 14.2333 17.6633 14.6183 17.92L15.6567 18.62C16.4267 19.1333 17.465 18.585 17.465 17.6517V11.6667H10.43Z'
        stroke='#343434'
        stroke-width='2'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  )
}
